import React from "react";
import { Autocomplete, TextField, Chip } from "@mui/material";
import { useFetchUsers } from "../../../hooks/api/adminApiHooks";

interface User {
  id: number;
  userName: string;
}

interface ResponsibleFilterProps {
  value: number[];
  onChange: (userIds: number[]) => void;
}

export default function ResponsibleFilter({
  value,
  onChange,
}: ResponsibleFilterProps) {
  const { usersData } = useFetchUsers();
  const users = usersData || [];

  // Converter IDs selecionados para objetos de usuário
  const selectedUsers = users.filter((user: User) => value.includes(user.id));

  const handleChange = (_event: any, newValue: User[]) => {
    const userIds = newValue.map((user) => user.id);
    onChange(userIds);
  };

  return (
    <Autocomplete
      multiple
      options={users}
      value={selectedUsers}
      onChange={handleChange}
      getOptionLabel={(option: User) => option.userName || ""}
      isOptionEqualToValue={(option: User, value: User) => option.id === value.id}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Responsáveis"
          placeholder="Selecione os responsáveis"
        />
      )}
      renderTags={(tagValue, getTagProps) =>
        tagValue.map((option, index) => (
          <Chip
            label={option.userName}
            {...getTagProps({ index })}
            key={option.id}
          />
        ))
      }
    />
  );
}

